export default __webpack_public_path__ + "static/media/snow-day.a17d49d7.svg";